import { useState } from "react";

const BADGE = {
  new: ["New", "bg-emerald-50 text-emerald-700"],
  duplicate: ["Already exists", "bg-slate-100 text-slate-600"],
  error: ["Error", "bg-rose-50 text-rose-700"],
};
const FILTERS = [["", "All", "total"], ["new", "New", "new"], ["duplicate", "Already exist", "duplicates"], ["error", "Errors", "errors"]];

const PreviewRow = ({ r }) => (
  <tr className="border-t border-[#E7E2D6]" data-testid={`lead-preview-row-${r.line}`}>
    <td className="px-2 py-1.5 font-mono text-xs text-muted-foreground">{r.line}</td>
    <td className="px-2 py-1.5"><div className="font-medium">{r.name || <span className="text-rose-600">(no name)</span>}</div><div className="text-xs text-muted-foreground">{[r.lead_type, r.area, r.pincode].filter(Boolean).join(" · ")}</div></td>
    <td className="px-2 py-1.5 font-mono text-xs">{r.phone || "-"}</td>
    <td className="px-2 py-1.5"><span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${BADGE[r.status][1]}`} data-testid={`lead-preview-status-${r.line}`}>{BADGE[r.status][0]}</span>{r.reason && <div className="mt-0.5 text-[11px] text-muted-foreground">{r.reason}</div>}</td>
  </tr>
);

export const LeadImportPreview = ({ data }) => {
  const [f, setF] = useState(data.errors ? "error" : "");
  const rows = data.rows.filter((r) => !f || r.status === f);
  return (
    <div className="space-y-2" data-testid="lead-import-preview">
      <div className="flex flex-wrap gap-1.5">
        {FILTERS.map(([k, l, n]) => (
          <button key={k || "all"} type="button" onClick={() => setF(k)} className={`rounded-full border px-3 py-1 text-xs transition-colors ${f === k ? "border-[#0F382C] bg-[#0F382C] text-white" : "border-[#E7E2D6] bg-white hover:border-[#0F382C]/40"}`} data-testid={`lead-preview-filter-${k || "all"}`}>{l} <span className="font-semibold">{data[n]}</span></button>
        ))}
      </div>
      <div className="max-h-72 overflow-auto rounded-xl border border-[#E7E2D6]">
        <table className="w-full text-left text-sm">
          <thead className="sticky top-0 bg-[#FBF9F4] text-[11px] uppercase tracking-wide text-muted-foreground"><tr><th className="px-2 py-1.5">Row</th><th className="px-2 py-1.5">Name</th><th className="px-2 py-1.5">Mobile</th><th className="px-2 py-1.5">Result</th></tr></thead>
          <tbody>{rows.map((r) => <PreviewRow key={r.line} r={r} />)}</tbody>
        </table>
        {rows.length === 0 && <div className="p-4 text-center text-xs text-muted-foreground" data-testid="lead-preview-empty">No rows here</div>}
      </div>
    </div>
  );
};
